import { Subject } from 'rxjs';

export class FileDto {
  id: string;
  bucketKey: string;
  path: string;
  name: string;

  constructor(id: string, bucketKey: string, path: string, name: string) {
    this.id = id;
    this.bucketKey = bucketKey;
    this.path = path;
    this.name = name;
  }
}

export class FileDownloadControlDto extends FileDto {
  isActive?: boolean;
  processing?: Subject<boolean>;
  file?: File;

  constructor(
    id: string,
    bucketKey: string,
    path: string,
    name: string,
    isActive: boolean,
    file?: File
  ) {
    super(id, bucketKey, path, name);
    this.isActive = isActive;
    this.file = file;
  }
}
